<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row>
      <v-col align="center" style="padding-bottom: 0%;" cols="12">
        <v-card class="slide-card" style="max-width: 90%;">
          <div
            class="slide-content text-justify"
            style="padding: 1% !important;"
          >
            <p>
              MARTA conducted a survey from May 28, 2021 through August 31,
              2021, to solicit input from the public on whether Bus Rapid
              Transit (BRT) or Light Rail Transit (LRT) would be the preferred
              high-capacity transit improvement for the Campbellton Road
              Corridor.
            </p>
            <p>
              The project team collected 621 paper surveys from residents and
              businesses along the corridor, at pop-up open house meetings, the
              Oakland City & Lakewood-Ft. McPherson MARTA rail stations and from
              riders on board the Route 83 bus. 317 online surveys were
              collected through the virtual meeting room.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="image in images"
        :key="image"
        align="center"
        :cols="columns"
      >
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <div style="cursor:pointer" @click="toggleDialog(image)">
          <v-img :src="renderImage(image)" style="width:85%" />
        </div>
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
        />
      </v-col>
    </v-row>
    <NewImagePopup
      v-if="toggled1"
      :close-modal="closeDialog"
      image="Campbellton_KeyFindings.png"
    />
    <NewImagePopup
      v-if="toggled2"
      :close-modal="closeDialog"
      image="Slide2.jpg"
    />
  </v-sheet>
</template>

<script>
import NewImagePopup from "@/components/NewImagePopup.vue";
// import PlayButton from "./common/PlayIcon.vue";

export default {
  name: "Overview",
  components: {
    NewImagePopup
    // PlayButton
  },
  data() {
    return {
      toggled1: false,
      toggled2: false,
      images: ["Campbellton_KeyFindings.png", "Slide2.jpg"],
      youtubeVideo: "https://www.youtube.com/embed/Wm6dvSlKNXI"
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "10%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "50%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    renderImage(image) {
      return require(`../../public/static/slides/${image}`);
    },
    toggleDialog(image) {
      this.image = image;
      if (image.includes("Campbellton_KeyFindings.png")) {
        this.toggled1 = !this.toggled1;
      }
      if (image.includes("2")) {
        this.toggled2 = !this.toggled2;
      }
    },
    closeDialog() {
      (this.toggled1 = false), (this.toggled2 = false);
    }
  }
};
</script>
